import {saveAs} from 'file-saver';
import {App as AntdApp} from 'antd';
import {useCallback} from 'react';
import {UseLazyQuery} from "@reduxjs/toolkit/dist/query/react/buildHooks";
import {BaseQueryFn, QueryDefinition} from "@reduxjs/toolkit/query";
import {FetchArgs, FetchBaseQueryError} from "@reduxjs/toolkit/query/react";
import {TagType} from '../../../store/services/api/base-api';
import {convertBase64toBlob} from "../../../utils/helpers";
import {ExcelExportResponse} from "../../../store/data/models/excel-export-response";

interface UseReportProps {
  query: UseLazyQuery<QueryDefinition<Record<string, any>, BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, TagType, ExcelExportResponse, "api">>
}

export const useExcelExport = ({query}: UseReportProps) => {
  const {notification: apiNotification} = AntdApp.useApp();
  const [getExcelExport, {isFetching}] = query();

  const handleError = useCallback(() => {
    apiNotification.error({
      message: 'Error',
      description: 'There was an issue downloading the report.',
      placement: 'bottomRight',
      duration: 3,
    });
  }, [apiNotification]);

  const exportExcel = useCallback(
  async (filters: Record<string, any>) => {
    try {
      const data = await getExcelExport(filters).unwrap();
      if (!data) {
        handleError();
        return;
      }

      let blob = convertBase64toBlob(data.base64, "application/vnd.ms-excel");
      saveAs(blob, 'export.xlsx');
    } catch {
      handleError();
    }
  },
  [getExcelExport, handleError]
);

  return {
    exportExcel,
    isLoading: isFetching,
  };
};
